import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class DepPosition  {
    _originalTypeClassName = "zERP.BO.DepPosition";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
DepPosition.translate = translateService;
}
this.Id = null;
this.Code = null;
this.Description = null;
this.From = null;
this.To = null;
this.Status = null;
this.ReplacementFullname = null;
this.EmployeeCode = null;
this.EmployeeSalary = null;
this.EmployeeRelationshipType = null;
this.FilledState = null;
this.PositionFilledDate = null;
this.ContractStartDate = null;
this.ContractEndDate = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Description:any;
From:any;
To:any;
Status:any;
ReplacementFullname:any;
EmployeeCode:any;
EmployeeSalary:any;
EmployeeRelationshipType:any;
FilledState:any;
PositionFilledDate:any;
ContractStartDate:any;
ContractEndDate:any;
Department:any;
WorkPosition:any;
EmployeeCategory:any;
DepPositionType:any;
DepPosTitle:any;
Technology:any;
static setDepartment = ($this, value) => {
var oldValue = $this.Department;
$this.Department = value;
if (value != null) {
if (oldValue != null) {
Domain.Department.removeDepPosition(oldValue, $this);
}
Domain.Department.addDepPosition(value, $this);
}
}
static setWorkPosition = ($this, value) => {
var oldValue = $this.WorkPosition;
$this.WorkPosition = value;
if (value != null) {
}
}
static setEmployeeCategory = ($this, value) => {
var oldValue = $this.EmployeeCategory;
$this.EmployeeCategory = value;
if (value != null) {
}
}
static setDepPositionType = ($this, value) => {
var oldValue = $this.DepPositionType;
$this.DepPositionType = value;
if (value != null) {
}
}
static setDepPosTitle = ($this, value) => {
var oldValue = $this.DepPosTitle;
$this.DepPosTitle = value;
if (value != null) {
}
}
static setTechnology = ($this, value) => {
var oldValue = $this.Technology;
$this.Technology = value;
if (value != null) {
}
}

static GetAllSubDepartments(department: any,departmentList: any): any{departmentList?.add(department);
if ((department?.Children != null && CLMS.Framework.Number.GreaterThan(() => department.Children.length, () => 0))) {for (let _ichild = 0; _ichild < (department?.Children == null ? 0 : department?.Children.length); _ichild++) {let child = department?.Children[_ichild];Domain.DepPosition.GetAllSubDepartments(child, departmentList);}}
}
static GetClassName(): any{return "DepPosition";
}
static ParseCertificationStatus(el: any): any{return (el == "Ενεργό" ? Domain.CertificationStatus.Active : Domain.CertificationStatus.Inactive);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}